"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProfileService = void 0;
const features_1 = require("../../features");
const initializer_1 = require("../../initializer");
const react_1 = require("react");
const useProfileServiceBase_hook_1 = require("./useProfileServiceBase.hook");
const useProfileService = () => {
    const profileRepository = (0, react_1.useRef)(new features_1.ProfileRepository(initializer_1.API));
    return (0, useProfileServiceBase_hook_1.useProfileServiceBase)(profileRepository.current);
};
exports.useProfileService = useProfileService;
//# sourceMappingURL=useProfileService.hook.js.map